export default "__VITE_PUBLIC_ASSET__5064fa88__"